import React, { useState, useEffect } from "react";
import api from "../services/api";
import toast from "react-hot-toast";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ nom:"", description:"", icone:"📦", couleur:"#1B3A8C" });
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/categories").then(r => setCats(r.data));
  useEffect(() => { load(); }, []);

  const submit = async e => {
    e.preventDefault();
    try {
      if (editing) { await api.put(`/categories/${editing.id}`, form); toast.success("Modifié"); }
      else { await api.post("/categories", form); toast.success("Catégorie créée"); }
      setShowForm(false); setEditing(null); load();
    } catch(e) { toast.error(e.response?.data?.error || "Erreur"); }
  };

  const del = async id => {
    if (!window.confirm("Supprimer ?")) return;
    await api.delete(`/categories/${id}`); toast.success("Supprimé"); load();
  };

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: "#1B3A8C" }}>Catégories</h1>
        <button onClick={() => { setShowForm(true); setEditing(null); setForm({ nom:"", description:"", icone:"📦", couleur:"#1B3A8C" }); }}
          style={{ background: "#1B3A8C", color: "#fff", border: "none", borderRadius: 8, padding: "10px 20px", fontWeight: 700, cursor: "pointer" }}>
          + Nouvelle catégorie
        </button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 20 }}>
        {cats.map(c => (
          <div key={c.id} style={{ background: "#fff", borderRadius: 12, padding: 20, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", borderTop: `4px solid ${c.couleur}` }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>{c.icone}</div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#222" }}>{c.nom}</div>
            <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>{c.description || "Aucune description"}</div>
            <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
              <button onClick={() => { setEditing(c); setForm({ nom:c.nom, description:c.description||"", icone:c.icone, couleur:c.couleur }); setShowForm(true); }}
                style={{ flex:1, background:"#F5A800", color:"#fff", border:"none", borderRadius:6, padding:"6px", cursor:"pointer", fontSize:12 }}>✏️ Modifier</button>
              <button onClick={() => del(c.id)}
                style={{ flex:1, background:"#dc3545", color:"#fff", border:"none", borderRadius:6, padding:"6px", cursor:"pointer", fontSize:12 }}>🗑️ Supprimer</button>
            </div>
          </div>
        ))}
      </div>
      {showForm && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <div style={{ background:"#fff", borderRadius:16, padding:32, width:440 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:20 }}>
              <h2 style={{ color:"#1B3A8C", fontSize:18, fontWeight:700 }}>{editing ? "Modifier" : "Nouvelle catégorie"}</h2>
              <button onClick={() => setShowForm(false)} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer" }}>✕</button>
            </div>
            <form onSubmit={submit}>
              {[["Nom *","nom"],["Description","description"],["Icône (emoji)","icone"]].map(([l,k]) => (
                <div key={k} style={{ marginBottom:14 }}>
                  <label style={{ display:"block", fontSize:12, color:"#555", marginBottom:4, fontWeight:600 }}>{l}</label>
                  <input value={form[k]} onChange={e => setForm({...form,[k]:e.target.value})}
                    style={{ width:"100%", padding:"8px 12px", border:"1px solid #ddd", borderRadius:6, fontSize:13 }} required={k==="nom"} />
                </div>
              ))}
              <div style={{ marginBottom:20 }}>
                <label style={{ display:"block", fontSize:12, color:"#555", marginBottom:4, fontWeight:600 }}>Couleur</label>
                <input type="color" value={form.couleur} onChange={e => setForm({...form, couleur:e.target.value})}
                  style={{ width:60, height:36, border:"none", cursor:"pointer" }} />
              </div>
              <div style={{ display:"flex", gap:12, justifyContent:"flex-end" }}>
                <button type="button" onClick={() => setShowForm(false)} style={{ padding:"10px 20px", border:"1px solid #ddd", borderRadius:8, cursor:"pointer" }}>Annuler</button>
                <button type="submit" style={{ padding:"10px 24px", background:"#1B3A8C", color:"#fff", border:"none", borderRadius:8, fontWeight:700, cursor:"pointer" }}>Enregistrer</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
